module.exports = __webpack_public_path__ + "img/sel_Beijing.92f86714.jpg";